export function tooV1InitializeCustomControlData() {
    return {
        familiaire_voorgeschiedenis: null,
        isPatientInformed: false,
        oculaire_voorgeschiedenis: null,
        omschrijf_de_duur_van_de_klachten: null,
        reden_van_verwijzing: {
            andersText: null,
            dubbel_zien: false,
            gezichtsveldklachten: false,
            hoofdpijn: false,
            prikken_jeuken_tranen: false,
            risicofactoren_glaucoom: false,
            rood_oog_droog_oog: false,
            verdenking_op_cataract: false,
            vervormd_zien: false,
            visusveranderingen: false,
            wazig_zien: false,
        },
        relevante_medische_voorgeschiedenis: null,
        toelichting: null,
    };
}
